import { get, post } from './common'
type ApiBaseResult<T> = Promise<ApiTypes.ApiBaseResult & T>

export namespace chat {
  export function createChatSession(): ApiBaseResult<{ data: { sessionId: string } }> {
    return post('/chat/session/create')
  }

  export function stopChatMessage(params: {
    sessionId: string
    messageId: number
  }): ApiBaseResult<{}> {
    return post('/chat/session/stop', params, params)
  }

  export function getChatHistory(params: {
    page: number
    pageSize: number
    keyword: string
  }): ApiBaseResult<{ dataList: ServerDataTypes.HistoryItem[]; total: number }> {
    return get('/chat/session/list', { ...params })
  }

  export function getChatDetail(params: {
    sessionId: string
  }): ApiBaseResult<{ data: ServerDataTypes.ChatDetail }> {
    return get('/chat/session/info', { ...params })
  }

  //================= 帮助中心 ========================

  export function defaultQuestionList(): ApiBaseResult<{
    dataList: { input: string; output: string }[]
  }> {
    return get('/helper/default/config')
  }

  export function getHelpCenterSessionInfo(): ApiBaseResult<{
    data: { sessionId: string; messageList: ServerDataTypes.MessageItem[] }
  }> {
    return get('/helper/session/info', {})
  }

  export function createHelpCenterSession(): ApiBaseResult<{
    data: { sessionId: string }
  }> {
    return post('/helper/session/create')
  }

  export function stopHelpCenterMessage(params: {
    sessionId: string
    messageId: number
  }): ApiBaseResult<{}> {
    return post('/', params, params)
  }

  //================= 帮助中心 ========================
}
